import {
  createColumnText,
  createColumnDate,
  createColumnPopover,
  formatNumber,
  renderWithDetail,
  widthOptions,
} from '@/components/table/function/createColumn';
import { ROUTES_PATH } from '@/resources/routes-name';
import { createColumnTag } from '../../../../components/table/function/createColumn';
import { color, Icon } from '../../../../resources';
import { WARRANTY_STATUS } from '../../../../resources/status';

export const columns = ({ handleDelete, privilegeAbmType }) => {
  const isRead = privilegeAbmType === 'READ';
  // ตาม release เดิม: เฉพาะ COMPLETED ที่ดูได้อย่างเดียว ส่วน CLAIMING (กำลังเคลม) ยังแก้ไขได้
  const isViewStatus = (record) => record.warrantyStatus === 'COMPLETED';
  const openDetail = (record) => {
    const url = `${ROUTES_PATH.ROUTE_REGISTRATION_VIEW.PATH}?code=${record.warrantyCode}`;
    window.open(url, '_blank');
  };
  const openEdit = (record) => {
    const url = `${ROUTES_PATH.ROUTE_EDIT_WARRANTY.PATH}?code=${record.warrantyCode}`;
    window.open(url, '_blank');
  };

  const menuItems = isRead
    ? [{ icon: Icon.detail, color: color.orangeTheme, text: 'ดูรายละเอียด', onClick: openDetail }]
    : [
        {
          icon: Icon.detail,
          color: color.orangeTheme,
          text: 'ดูรายละเอียด',
          visible: isViewStatus,
          onClick: openDetail,
        },
        {
          icon: Icon.edit2,
          color: color.orangeTheme,
          text: 'แก้ไข',
          visible: (record) => !isViewStatus(record),
          onClick: openEdit,
        },
        {
          icon: Icon.remove,
          color: color.search2,
          text: 'ยกเลิกรับประกัน',
          visible: (record) => record.warrantyStatus === 'ACTIVE',
          confirm: {
            title: 'คุณต้องการยกเลิกการรับประกันหรือไม่?',
            onConfirm: (record) => handleDelete(record),
          },
        },
      ];

  return [
    createColumnTag(
      'สถานะ',
      { key: 'warrantyStatus', text: 'warrantyStatus', icon: true },
      WARRANTY_STATUS,
    ),
    createColumnText(
      'เลขที่รับประกัน',
      'warrantyCode',
      widthOptions(200, {
        onFilter: (value, record) =>
          [record.warrantyCode, record.createDate].some((item) =>
            item?.toString().toLowerCase().includes(value.toLowerCase()),
          ),
        render: (text, record) =>
          renderWithDetail(text, `วันที่ลงทะเบียน: ${record.createDate || '-'}`),
      }),
    ),
    createColumnText(
      'ชื่อ-นามสกุล',
      'fullName',
      widthOptions(200, {
        onFilter: (value, record) =>
          [record.fullName, record.telephone, record.lineName].some((item) =>
            item?.toString().toLowerCase().includes(value.toLowerCase()),
          ),
        render: (text, record) =>
          renderWithDetail(
            text,
            [record.telephone, record.lineName && `LINE: ${record.lineName}`]
              .filter(Boolean)
              .join(' · ') || '-',
          ),
      }),
    ),
    createColumnText('รหัสสินค้า', 'itemCode', widthOptions(210)),
    createColumnText('ชื่อสินค้า', 'productName', widthOptions(150)),
    createColumnText('รหัสรับประกัน', 'warrantyNumberCode', widthOptions(160)),
    createColumnText(
      'รุ่น',
      'mobileModelName',
      widthOptions(200, {
        onFilter: (value, record) =>
          [record.mobileModelName, record.mobileBrandName].some((item) =>
            item?.toString().toLowerCase().includes(value.toLowerCase()),
          ),
        render: (text, record) => renderWithDetail(text, record.mobileBrandName || '-'),
      }),
    ),
    createColumnText('ช่องทางการซื้อ', 'channelBuyName', widthOptions(230)),
    createColumnText('ร้านค้า', 'storeName', widthOptions(150)),
    createColumnDate(
      'วันหมดอายุ',
      'expireDate',
      widthOptions(200, {
        onFilter: (value, record) =>
          [record.expireDate, record.remainingDays].some((item) =>
            item?.toString().toLowerCase().includes(value.toLowerCase()),
          ),
        render: (text, record) => {
          const remainingText =
            record.remainingDays > 100000 ? 'ตลอดชีวิต' : formatNumber(record.remainingDays);
          return renderWithDetail(text, remainingText);
        },
      }),
    ),
    createColumnPopover({
      title: 'จัดการ',
      dataIndex: 'rowNo',
      contentOptions: { menuItems },
      options: {
        others: {
          fixed: 'right',
          width: 80,
        },
      },
    }),
  ];
};

export const exportHeaders = [
  { dataIndex: 'warrantyCode', title: 'เลขที่รับประกัน' },
  { dataIndex: 'warrantyNumberCode', title: 'รหัสรับประกัน' },
  { dataIndex: 'categoryCode', title: 'หมวดหมู่' },
  { dataIndex: 'warrantyStatus', title: 'สถานะ' },
  { dataIndex: 'mobileBrandName', title: 'แบรนด์' },
  { dataIndex: 'mobileModelName', title: 'รุ่น' },
  { dataIndex: 'itemCode', title: 'รหัสสินค้า' },
  { dataIndex: 'productName', title: 'ชื่อสินค้า' },
  { dataIndex: 'channelBuyName', title: 'ช่องทางการซื้อ' },
  { dataIndex: 'fullName', title: 'ชื่อ-นามสกุล' },
  { dataIndex: 'telephone', title: 'เบอร์โทร' },
  { dataIndex: 'email', title: 'อีเมลล์' },
  { dataIndex: 'createDate', title: 'วันที่ลงทะเบียน' },
  { dataIndex: 'claimCode', title: 'เลขที่เคลม' },
  { dataIndex: 'claimRemark', title: 'สาเหตุการเคลม' },
  { dataIndex: 'claimDate', title: 'วันที่เคลม' },
  { dataIndex: 'lineUid', title: 'ไลน์ UID' },
  { dataIndex: 'superMemberStatus', title: 'Super Member' },
];
